<template>
  <span>{{ animatedNumber.toFixed(0) }}</span>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  target: {
    type: Number,
    required: true,
  },
  duration: {
    type: Number,
    default: 1000, // milliseconds
  },
});

const animatedNumber = ref(0);
let animationFrameId = null;
let startTime = null;

const animate = (currentTime) => {
  if (!startTime) startTime = currentTime;
  const progress = (currentTime - startTime) / props.duration;

  if (progress < 1) {
    animatedNumber.value = props.target * progress;
    animationFrameId = requestAnimationFrame(animate);
  } else {
    animatedNumber.value = props.target;
    cancelAnimationFrame(animationFrameId);
  }
};

const startAnimation = () => {
  cancelAnimationFrame(animationFrameId); // Clear any existing animation
  startTime = null; // Reset start time
  animatedNumber.value = 0; // Start from 0
  animationFrameId = requestAnimationFrame(animate);
};

// Watch for changes in target prop to re-run animation
watch(() => props.target, () => {
  startAnimation();
});

onMounted(() => {
  startAnimation();
});

onUnmounted(() => {
  cancelAnimationFrame(animationFrameId);
});
</script>
